export const ReportStore = {

};
